import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import Layout from "./Layout";
import { ChevronRight, Menu } from "lucide-react";

export default function Portfolio() {
  const { isDark } = useTheme();

  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = [
    {
      name: "Backend",
      path: "/portfolio/backend",
      description:
        "Server-side applications, System Architecture and performance",
    },
    {
      name: "DevOps",
      path: "/portfolio/devops",
      description: "Infrastructure, CI/CD, and deployment automation",
    },
    // {
    //   name: "Mobile Application",
    //   path: "/portfolio/mobile",
    //   description: "iOS and Android applications",
    // },
  ];

  const handleCategoryClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Layout>
      {({ toggleMobileMenu }) => (
        <div className="flex flex-col items-center px-4 py-6 sm:px-6 sm:py-8 lg:px-10 lg:py-12">
          <div className="w-full max-w-content">
            {/* Mobile Menu Button */}
            <div className="mb-8 lg:hidden">
              <button
                onClick={toggleMobileMenu}
                className={`p-2 rounded-lg ${
                  isDark
                    ? "text-gray-400 hover:text-white hover:bg-gray-700"
                    : "text-text-muted hover:text-text hover:bg-gray-100"
                }`}
                aria-label="Toggle menu"
              >
                <Menu size={20} />
              </button>
            </div>

            {/* Page Header */}
            <header className="mb-12">
              <h1
                className={`text-4xl font-display font-semibold mb-8 tracking-tight ${
                  isDark ? "text-white" : "text-text"
                }`}
              >
                Portfolio
              </h1>

              {/* Overview Section */}
              <div className="mb-12">
                <h2
                  className={`text-2xl font-display font-semibold mb-4 tracking-tight ${
                    isDark ? "text-white" : "text-text"
                  }`}
                >
                  Overview
                </h2>
                <p
                  style={{
                    fontSize: "1rem",
                    lineHeight: "1.75",
                    fontWeight: "400",
                    color: isDark
                      ? "oklch(55% 0.013 144.91)"
                      : "oklch(35% 0.013 144.91)",
                  }}
                >
                  This portfolio contains Projects done for clients by me and
                  some of my personal projects I've worked on over the years.
                  Each listing details some of the backgrounds of the project
                  and my areas of focus.
                </p>
              </div>
            </header>

            {/* Categories Timeline */}
            <section>
              <h2
                className={`text-2xl font-display font-semibold mb-8 tracking-tight ${
                  isDark ? "text-white" : "text-text"
                }`}
              >
                Project Categories
              </h2>
              <div className="space-y-4">
                {categories.map((category, index) => (
                  <Link
                    key={index}
                    to={category.path}
                    onClick={handleCategoryClick}
                    className="group block"
                  >
                    {/* Category Card */}
                    <div
                      className={`flex items-center justify-between p-6 rounded-lg border transition-all duration-base ${
                        isDark
                          ? "bg-background-dark border-border-dark hover:border-primary-dark/50"
                          : "bg-background-sidebar border-border/50 hover:border-primary/50 hover:shadow-sm"
                      }`}
                    >
                      <div>
                        <h3
                          className={`text-xl font-display font-semibold mb-1 transition-colors duration-base ${
                            isDark
                              ? "text-white group-hover:text-primary-dark"
                              : "text-text group-hover:text-primary"
                          }`}
                        >
                          {category.name}
                        </h3>
                        <p
                          className={`text-sm ${
                            isDark ? "text-gray-400" : "text-text-muted"
                          }`}
                        >
                          {category.description}
                        </p>
                      </div>
                      <ChevronRight
                        size={20}
                        className={`transition-all duration-base ${
                          isDark
                            ? "text-gray-400 group-hover:text-primary-dark group-hover:translate-x-1"
                            : "text-text-muted group-hover:text-primary group-hover:translate-x-1"
                        }`}
                      />
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          </div>
        </div>
      )}
    </Layout>
  );
}
